'use client';

import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx';

export type SkeletonPreset = 'none' | 'line' | 'card' | 'media';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  preset?: SkeletonPreset;
}

function presetClass(preset: SkeletonPreset | undefined): string {
  switch (preset) {
    case 'line':
      return 'h-4 w-full rounded-md';
    case 'card':
      return 'h-32 w-full rounded-xl';
    case 'media':
      return 'h-36 w-full rounded-2xl opacity-70 ring-1 ring-secondary_alt';
    case 'none':
    default:
      return '';
  }
}

export function Skeleton({ preset = 'none', className, ...props }: SkeletonProps) {
  return <div {...props} aria-hidden="true" className={cx('animate-pulse rounded-md bg-tertiary', presetClass(preset), className)} />;
}

Skeleton.displayName = 'Skeleton';
